import { render, staticRenderFns } from "./capital.vue?vue&type=template&id=6191a644&scoped=true"
import script from "./capital.vue?vue&type=script&lang=js"
export * from "./capital.vue?vue&type=script&lang=js"
import style0 from "./capital.vue?vue&type=style&index=0&id=6191a644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6191a644",
  null
  
)

export default component.exports